import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
	mainHeader: {
		display: "flex",
		alignItems: "center",
		padding: theme.spacing(1, 0, 1.5, 0),
		flexWrap: "wrap",
		gap: theme.spacing(1),
	},
}));

const MainHeader = ({ children }) => {
	const classes = useStyles();

	return <div className={classes.mainHeader}>{children}</div>;
};

export default MainHeader;
